import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Breadcrumbs } from 'src/app/shared/models/breadcrumbs';
import { SupplierException } from 'src/app/shared/models/supplier-exception';
import { SupplierProfile } from 'src/app/shared/models/supplier-profile';
import { DataService } from 'src/app/shared/services/data-service/data.service';
import { StoreService } from 'src/app/shared/services/store-service/store.service';
import { UserService } from 'src/app/shared/services/user-service/user.service';

@Component({
  standalone: false,
  selector: 'app-view-supplier-profile-detail',
  templateUrl: './view-supplier-profile-detail.component.html',
  styleUrls: ['./view-supplier-profile-detail.component.scss'],
})
export class ViewSupplierProfileDetailComponent implements OnInit {
  currentSupplierProfile: SupplierProfile;
  loading: boolean = true;
  breadcrumbItems: Breadcrumbs[];

  constructor(
    private router: Router,
    private userService: UserService,
    private dataService: DataService,
    public storeService: StoreService
  ) {}

  async ngOnInit(): Promise<void> {
    // TODO: smart way to do this?
    let vendPlant = this.router.url.split('/').pop();
    let vendorURL = vendPlant?.split('-')[0];
    let plantURL = vendPlant?.split('-')[1];
    let suppplierURL = this.router.url.split('/')[2];

    // Get supplier profile
    await this.dataService.initSupplierProfiles();

    // Get current supplier profile
    this.currentSupplierProfile = this.storeService.supplierProfiles.filter(
      (data) => {
        return (
          data.supplierIdentity == suppplierURL &&
          data.vendCode == vendorURL &&
          data.plantCode == plantURL
        );
      }
    )[0];

    this.loading = false;
    this.getPlantVendorDescription();
    this.buildBreadcrumbs();
  }

  buildBreadcrumbs() {
    var vendPlant =
      this.currentSupplierProfile.vendCode +
      '-' +
      this.currentSupplierProfile.plantCode;

    this.breadcrumbItems = [
      {
        text: 'Supplier Profile',
        link: '/supplier-profile',
      },
      {
        text: this.currentSupplierProfile.supplierIdentity,
        link:
          '/supplier-profile/' + this.currentSupplierProfile.supplierIdentity,
      },
      {
        text: vendPlant,
        link:
          '/supplier-profile/' +
          this.currentSupplierProfile.supplierIdentity +
          '/' +
          vendPlant,
      },
    ];
  }

  async handleCancelException(exceptionsToSave: SupplierException[]) {
    this.currentSupplierProfile.exceptions = exceptionsToSave;
  }

  async handleSaveException(exceptionsToSave: SupplierException[]) {
    this.loading = true;

    // Get current user
    let currentUser = (await this.userService.getUserDetail()).name;

    // Filter out new exception
    exceptionsToSave = exceptionsToSave.filter(
      (data: SupplierException) => data.criteria != 'New'
    );

    // Add entry without any exception if all exception deleted
    if (!exceptionsToSave.find((x) => !x.isDeleted)) {
      var blankException = <SupplierException>{
        criteria: '',
        value: '',
        isDeleted: false,
      };
      exceptionsToSave.push(blankException);
    }

    // Prepare supplier profile
    this.currentSupplierProfile.exceptions = exceptionsToSave;
    this.currentSupplierProfile.lastChangedBy = currentUser!;

    // Call API to create
    let result = await this.dataService.changeSupplierProfile(
      this.currentSupplierProfile
    );

    // Create Success, update store & navigate
    this.currentSupplierProfile.exceptions =
      this.currentSupplierProfile.exceptions.filter(
        (x) => !x.isDeleted && x.criteria != ''
      );
    if (result) {
      this.loading = false;
      this.storeService.updateSupplierProfile(this.currentSupplierProfile);
      var url = `${this.currentSupplierProfile.supplierIdentity}/${this.currentSupplierProfile.vendCode}-${this.currentSupplierProfile.plantCode}`;
      this.router.navigate([`/supplier-profile/${url}`]);
    }
  }

  async getPlantVendorDescription() {
    if (!this.currentSupplierProfile.plantDescription)
      this.currentSupplierProfile.plantDescription =
        await this.dataService.getPlantDescription(
          this.currentSupplierProfile.plantCode
        );
    if (!this.currentSupplierProfile.vendDescription)
      this.currentSupplierProfile.vendDescription =
        await this.dataService.getVendorDescription(
          this.currentSupplierProfile.vendCode
        );
  }

  delete(profile: SupplierProfile) {
    if (
      confirm('Are you sure to remove this vendor: ' + profile.vendCode + '?')
    ) {
      // Delete profile
      this.dataService.deleteProfile(profile);
      // delete data store
      this.storeService.deleteSupplierProfile(profile);

      // Checking, This is the last vendor in profile
      let currentSupplierProfiles = this.storeService.supplierProfiles.filter(
        (x) => x.supplierIdentity === profile.supplierIdentity
      );

      if (currentSupplierProfiles.length == 0) {
        // delete data store
        this.storeService.deleteSupplierList(profile);
        // Navigate back to list page
        this.router.navigate(['/supplier-profile/']);
      } else {
        this.router.navigate([
          '/supplier-profile',
          this.currentSupplierProfile.supplierIdentity,
        ]);
      }
    }
  }
}

